import { render, staticRenderFns } from "./game-4.vue?vue&type=template&id=0a30919e&scoped=true&"
import script from "./game-4.vue?vue&type=script&lang=js&"
export * from "./game-4.vue?vue&type=script&lang=js&"
import style0 from "./game-4.vue?vue&type=style&index=0&id=0a30919e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a30919e",
  null
  
)

export default component.exports